import cx from 'classnames'
import { forwardRef } from 'react'
import { MobileButtonProps } from './Types'
import { useObjectRef } from '@react-aria/utils'
import { useButton } from '@react-aria/button'
import Styles from './MobileButton.module.scss'
import { useHover } from '@react-aria/interactions'

export const MobileButton = forwardRef<HTMLDivElement, MobileButtonProps>(
  ({ icon: Icon, isActive = false, onPress, children }, fRef) => {
    const ref = useObjectRef(fRef)
    const { buttonProps, isPressed } = useButton({ onPress, elementType: 'div' }, ref)
    const { hoverProps, isHovered } = useHover({})

    return (
      <div
        {...buttonProps}
        {...hoverProps}
        className={cx(Styles.mobileButton, {
          [Styles.active]: isActive,
          [Styles.hovered]: isHovered,
          [Styles.pressed]: isPressed,
        })}
        ref={ref}
      >
        <Icon />
        <div className={Styles.label}>{children}</div>
      </div>
    )
  },
)
